module.exports = __webpack_public_path__ + "videos/video-oneclick-benefit-land.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/oneclick/video-oneclick-benefit-land.mp4
// module id = 913
// module chunks = 1